import React, { HTMLAttributes } from 'react';
import ContentCard from '../ContentCard';
import { DiscoverySpeaker } from '../../../../../../store/features/discovery';
import Link from '../../../../../shared/Link/Link';
import { SiteTypes } from '../../../../../../types';
import { useGetImgixImageUrl } from '../../../../../../hooks';
import { useBuildUrl } from '../../../../../../hooks/useBuildUrl';
import styles from './SpeakerCard.module.scss';

export interface SpeakerCardProps
  extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  data: DiscoverySpeaker;
  siteType: SiteTypes;
}

export function SpeakerCard(props: SpeakerCardProps) {
  const {
    title,
    path,
    jobTitle,
    company,
    photo,
    forename,
    honorific,
    surname,
    displayHonorific,
  } = props.data;
  const pagePath = props.siteType === 'COURSE' ? 'trainers' : 'speakers';
  const image = useGetImgixImageUrl(photo);
  const url = useBuildUrl(pagePath, path);
  const shouldDisplayHonorific = displayHonorific && honorific ? honorific : '';

  const speakersPageTitle = `${shouldDisplayHonorific} ${forename ?? ''} ${
    surname ?? ''
  }`;
  const renderTitle = (
    <div className={styles.title}>{title || speakersPageTitle}</div>
  );

  const renderImage = (
    <div
      data-testid="speaker-photo"
      style={{
        backgroundImage: image
          ? `url(${image})`
          : '/images/default-silhouette.png',
      }}
      className={styles.image}
    />
  );

  const renderDescription = (
    <div className={styles.description}>{jobTitle}</div>
  );

  const renderFooter = <div className={styles.footer}>{company}</div>;

  return (
    <Link to={url} className={styles.link}>
      <ContentCard
        image={renderImage}
        title={renderTitle}
        description={renderDescription}
        footer={renderFooter}
        className="site-card"
      />
    </Link>
  );
}
